module.exports = "/3068/img/member-bg.5b76c989.png";